/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Select_Marker_LabelInputs */

const en_markers_select_marker_label = /** @type {(inputs: Markers_Select_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select marker`)
};

const fr_markers_select_marker_label = /** @type {(inputs: Markers_Select_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner le marqueur`)
};

const de_markers_select_marker_label = /** @type {(inputs: Markers_Select_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marker auswählen`)
};

const it_markers_select_marker_label = /** @type {(inputs: Markers_Select_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona marcatore`)
};

const ru_markers_select_marker_label = /** @type {(inputs: Markers_Select_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите маркер`)
};

const es_markers_select_marker_label = /** @type {(inputs: Markers_Select_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar marcador`)
};

const zh_cn2_markers_select_marker_label = /** @type {(inputs: Markers_Select_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择标记`)
};

const ja_markers_select_marker_label = /** @type {(inputs: Markers_Select_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーを選択`)
};

const hi_markers_select_marker_label = /** @type {(inputs: Markers_Select_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर का चयन करें`)
};

const pt_pt2_markers_select_marker_label = /** @type {(inputs: Markers_Select_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o marcador`)
};

/**
* | output |
* | --- |
* | "Select marker" |
*
* @param {Markers_Select_Marker_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_select_marker_label = /** @type {((inputs?: Markers_Select_Marker_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Select_Marker_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_select_marker_label(inputs)
	if (locale === "de") return de_markers_select_marker_label(inputs)
	if (locale === "it") return it_markers_select_marker_label(inputs)
	if (locale === "ru") return ru_markers_select_marker_label(inputs)
	if (locale === "es") return es_markers_select_marker_label(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_select_marker_label(inputs)
	if (locale === "ja") return ja_markers_select_marker_label(inputs)
	if (locale === "hi") return hi_markers_select_marker_label(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_select_marker_label(inputs)
	return en_markers_select_marker_label(inputs)
});